import React from 'react'
import NFLTemplate from 'src/components/page/nfl'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <NFLTemplate {...props} team="Miami Dolphins" teamShort="Dolphins" teamId={teamIds['Miami Dolphins']} />
)
